var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMapsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.99996H9.33333V7.33329H8V5.99996ZM9.33333 3.33329H8V4.66663H9.33333V3.33329ZM5.33333 9.99996H6.66667V8.66663H5.33333V9.99996ZM6.66667 3.33329H5.33333V4.66663H6.66667V3.33329ZM5.33333 7.33329H6.66667V5.99996H5.33333V7.33329ZM4 3.33329H2.66667V4.66663H4V3.33329ZM4 5.99996H2.66667V7.33329H4V5.99996ZM7.7 14H6.66667V11.6666H5.33333V14H1.33333V1.99996H10.6667V7.35329C11.14 7.39329 11.5933 7.53996 12 7.75329V0.666626H0V15.3333H8.60667C8.33333 14.96 8 14.5066 7.7 14ZM2.66667 12.6666H4V11.3333H2.66667V12.6666ZM4 8.66663H2.66667V9.99996H4V8.66663ZM12.6667 11C12.6667 12.7333 10.3333 15.3333 10.3333 15.3333C10.3333 15.3333 8 12.7333 8 11C8 9.73329 9.06667 8.66663 10.3333 8.66663C11.6 8.66663 12.6667 9.73329 12.6667 11ZM11.1333 11.0666C11.1333 10.6666 10.7333 10.2666 10.3333 10.2666C9.93333 10.2666 9.53333 10.6 9.53333 11.0666C9.53333 11.4666 9.86667 11.8666 10.3333 11.8666C10.8 11.8666 11.2 11.4666 11.1333 11.0666Z",
    fill: "#A5AEB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapsIcon);
export default __webpack_public_path__ + "static/media/google-maps-icon.e1847af8d6235e24e7eefcb38aa20d06.svg";
export { ForwardRef as ReactComponent };